<script lang="ts">
  import Footer from './footer.svelte';
  import Header from './header.svelte';
</script>

<main
  class="bg-default-50 font-neue text-default-900 dark:bg-store-dark dark:text-default-50 flex min-h-[100vh] flex-col"
>
  <Header />
  <slot />
  <Footer />
</main>
